<script setup>
import { defineProps, defineEmits, ref } from 'vue';
import Checkbox from '@/components/checkbox.vue';

const props = defineProps({
    show: {
        tyoe: Boolean,
        default: false
    }
})
const isConfirmed = ref(false);
const requiredInfos = ref([
    {
        label: 'Methodology & Sources',
        description: 'Data sources, steps and other methodology details.'
    },
    {
        label: 'Quality Assurances',
        description: 'Share how you will ensure this data is of high quality.'
    },
    {
        label: 'Credentials & Experience',
        description: 'Tell the RFP issuer why you are the best prepared to respond..'
    },

])

const emit = defineEmits(['isConfirmed', 'close']);

const handleConfirm = () => {
    emit('isConfirmed');
}

</script>

<template>
    <Teleport to="body">
        <div v-if="props.show" class="modal-overlay" data-modal>
            <div ref="modalRef" class="modal">
                <div class="modal__header">
                    <h2 class="modal__title">Submit Proposal</h2>
                </div>
                <div class="modal__description">
                    <div>Send your proposal to the RFP issuer for review. Before you submit, check your proposal includes the following details:</div>
                </div>
                <div class="modal__details">
                    <div class="flex gap-2" v-for="field in requiredInfos" :key="field.label">
                        <div class="w-2 h-2 bg-echoes-primary/80 rounded-full mt-2"></div>
                        <div class="flex flex-col mb-2">
                            <div class="font-medium">{{ field.label }}</div>
                            <div class="text-white/60 text-xs">{{ field.description }}</div>
                        </div>
                    </div>
                </div>
                <div class="modal__description">
                    Make sure your proposal is complete, you cannot edit it once it has been submitted.
                </div>
                <div>
                    <div class="flex items-start gap-2 mb-6">
                        <Checkbox v-model="isConfirmed" required />
                        <div class="flex flex-col">
                            <span for="confirmBid" class="text-sm text-echoes-primary font-semibold">Confirm Submission</span>
                            <span class="text-xs text-gray-500">I agree woth the above and with the 
                                <a href="https://portexai.com/tou" target="_blank" class="hover:text-echoes-primary underline">Terms of Use</a></span>
                        </div>
                    </div>
                </div>
                <div class="modal__footer">
                    <button class="px-4 py-2 rounded-lg hover:bg-white/10 text-white" @click="emit('close')">Close</button>
                    <button class="text-white px-4 py-2 rounded-lg" :class="isConfirmed ? 'bg-echoes-primary' : 'bg-echoes-primary/50 cursor-not-allowed'" @click="handleConfirm" :disabled="!isConfirmed">Submit Proposal</button>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped lang="postcss">
.modal-overlay {
    @apply fixed inset-0 bg-black/50 flex items-center justify-center z-40 p-2;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.2s ease;
    isolation: isolate;
}

.modal {
    @apply bg-echoes-background-gray border border-echoes-border-gray/50 rounded-xl shadow-xl max-h-[85vh] mt-16 flex flex-col w-2/5 px-8;
    animation: slideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    z-index: 1;
}

.modal__header {
    @apply sticky top-0 z-10 flex items-center justify-between pt-4 p-2 border-b border-echoes-border-gray bg-echoes-background-gray rounded-t-xl;
}

.modal__title {
    @apply text-xl font-semibold text-white flex items-center gap-2;
}

.modal__description {
    @apply p-2 bg-echoes-background-gray rounded-b-xl text-sm text-white/60;
}

.modal__details {
    @apply mx-2 px-4 py-2 bg-echoes-background-black rounded-xl my-2;
}

.modal__footer {
    @apply px-4 bg-echoes-background-gray rounded-b-xl text-sm text-white/60 flex justify-center my-4 gap-4;
}
</style>